<template>
   <head>
    <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;700&display=swap" rel="stylesheet">
    <meta name="viewport" content="width=device-width, initial-scale=1.0"> 
  </head>
    <section class="relative h-screen w-full">
      <!-- Image de fond -->
      <img src="/image/im2.jpg" alt="Contact Us" class="absolute top-0 left-0 w-full h-full object-cover z-0" />
  
     
      <div class="absolute inset-0 flex items-center justify-center z-10 bg-black bg-opacity-40">
        <div class="bg-white bg-opacity-90 p-8 rounded-xl shadow-xl w-full max-w-md text-center space-y-6">
         
          <img src="/image/log.png" alt="Logo HotelBook" class="mx-auto h-24 w-24" />
  
          
          <p class="text-gray-700 text-sm italic font-serif">Connectez-vous avec vos identifiants qui vous ont été fournis à l'inscription.</p>
  
        
          <form @submit.prevent="login" class="space-y-6">
         
            <div>
              <input
                  v-model="matricule"
                  type="text"
                  placeholder="Matricule"
                  required
                  class="w-full border-b-2 border-gray-300 bg-transparent focus:outline-none focus:border-blue-500 p-2 font-serif placeholder-gray-500"
                />

            </div>
  
          
            <div>
              <input
                v-model="password"
                type="password"
                placeholder="Mot de passe"
                required
                class="w-full border-b-2 border-gray-300 bg-transparent focus:outline-none focus:border-blue-500 p-2 font-serif placeholder-gray-500"
              />
            </div>
  
            
            <button
              type="submit"
              class="px-6 py-2 bg-blue-900 text-white text-sm rounded-md hover:bg-blue-800 transition duration-300 font-serif"
            >
              Se connecter
            </button>
          </form>
  
         
          <p class="text-gray-600 text-xs mt-2 font-serif">Pas encore de compte ? Inscrivez vous sur notre site officiel.</p>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    data() {
      return {
        email: '',
        password: '',
        user: null
      };
    },
    methods: {
      login() {
        fetch('https://mida-back.onrender.com/api/login', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
    matricule: this.matricule, 
    password: this.password
  })
})
.then(response => response.json())
.then(data => {
  if (data.access_token) {
    localStorage.setItem('token', data.access_token);
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('niveau', data.user.niveau);
    localStorage.setItem('matricule', data.user.matricule);

    alert('Connexion réussie !');
    this.$router.push('/dashboard');
  } else {
    alert(data.message || 'Identifiants incorrects.');
  }
})
.catch(error => {
  console.error('Erreur lors de la connexion:', error);
  alert('Erreur de connexion. Vérifiez votre serveur.');
});

    }
  }
};
  </script>
  